import { iots } from '@code-expert/prelude';
import { CourseUrl, SemesterId } from '/imports/domain';

export const pageKeys = {
  analytics: null,
  appointments: null,
  backup: null,
  codeExamples: null,
  exercises: null,
  groups: null,
  invitations: null,
  ltiGrading: null,
  messages: null,
  regrade: null,
  settings: null,
  students: null,
};

export const Page = iots.keyof(pageKeys);
export type Page = keyof typeof pageKeys;

export const MyCoursesPageParams = iots.struct(
  {
    semester: SemesterId,
    courseUrl: CourseUrl,
  },
  {
    page: Page,
  },
);

export type MyCoursesPageParams = iots.TypeOf<typeof MyCoursesPageParams>;

export const defaultPage: Page = 'exercises';
